import { XDatePicker } from '@adornis/datetime/x-date-picker.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-date-picker
 */
@customElement('cr-date-picker')
export class ChromiumDatePicker extends XDatePicker {}
